export default __webpack_public_path__ + "static/media/medium-white.89463959.svg";